var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"viewBox":_vm.viewBox,"width":_vm.width,"height":_vm.height,"fill":_vm.computedColor,"stroke":_vm.stroke}})
}
var staticRenderFns = []

export { render, staticRenderFns }